var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button-reset chat-button",on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('Icon',{attrs:{"name":"chat","width":30,"height":28}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }